const CloseButton = ({ onClick }) => {
  return (
    <button
      className="close-button"
      style={{
        position: "absolute",
        top: "15px",
        right: "20px",
        background: "transparent",
        border: "none",
        fontSize: "40px",
        cursor: "pointer",
        zIndex: 100,
      }}
      onClick={() => onClick(false)} // 클릭 시 Modal 닫기
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="1"
          y1="23"
          x2="23"
          y2="1"
          stroke="#000"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="1"
          y1="1"
          x2="23"
          y2="23"
          stroke="#000"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
};

export default CloseButton;
